// @ts-nocheck
import { Navigate, Outlet } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

import { useAuth } from '@/contexts/AuthContext'

const GuestRoute = () => {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='100vh'>
        <CircularProgress />
      </Box>
    )
  }

  if (isAuthenticated) {
    return <Navigate to='/en/dashboard' replace />
  }

  return <Outlet />
}

export default GuestRoute
